export const REDUX_ACTION_LOGGING_ADD_REALTIME_LOG = 'add_realtime_log'
